import {
  EuiButtonIcon,
  EuiHealth,
  EuiImage,
  EuiLink,
  euiPaletteColorBlindBehindText,
} from "@elastic/eui";
import {
  ActionIcon,
  Anchor,
  Button,
  Divider,
  Grid,
  Group,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { IconSearch, IconTrash } from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { styleTableMantine } from "../../../_base/_const/_constVar";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../../_base/extension/StringExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { ParamSearchBase } from "../../../_base/model/_base/ParamSearchBase";
import AppAction from "../../../common/AppAction";
import { _localization } from "../../../config/location";
import { API_ROUTE } from "../../../const/apiRoute";
import { tblFixedContent } from "../../../model/FixedContent";
import { MessageResponse } from "../../../model/MessageResponse";
import CreateView from "./CreateView";
import DeleteView from "./DeleteView";
import EditView from "./EditView";
import { useLocation } from "react-router-dom";
import { convertImageDomain } from "../../../const/converhandle";

const visColorsBehindText = euiPaletteColorBlindBehindText();

const optionSearch = [
  {
    value: true,
    label: "Kích hoạt",
    "data-test-subj": "titanOption",
    color: visColorsBehindText[0],
  },
  {
    value: false,
    label: "Chưa kích hoạt",
    color: visColorsBehindText[1],
  },
];
const FixedContent = () => {
  // const columns: Array<EuiBasicTableColumn<any>> = [
  //   {
  //     field: "id",
  //     name: "ID",
  //     sortable: true,
  //     truncateText: true,
  //     width: "3%",
  //   },
  //   {
  //     field: "title",
  //     name: "Danh sách nội dung cố định",
  //     sortable: true,
  //     truncateText: true,
  //     render: (itemName: string) => (
  //       <EuiLink
  //         target="_blank"
  //         onClick={(e: any) => {
  //           const item = datas.find((x) => x.title === itemName);
  //           if (item !== undefined && item?.id > 0) handleEditData(item?.id);
  //         }}
  //       >
  //         {itemName}
  //       </EuiLink>
  //     ),
  //   },

  //   {
  //     field: "linkIndex",
  //     name: "Link",
  //     sortable: true,
  //     truncateText: true,
  //     render: (link: string) => (
  //       <EuiLink target="_blank" href={link}>
  //         Xem trang bài viết
  //       </EuiLink>
  //     ),
  //   },
  //   {
  //     field: "image",
  //     name: "Ảnh nội dung cố định",
  //     sortable: true,
  //     truncateText: true,
  //     width: "13%",
  //     render: (uploadFile: string | null) => {
  //       return uploadFile === null ? null : (
  //         <EuiImage width={60} height={100} src={uploadFile} alt="file" />
  //       );
  //     },
  //   },
  //   {
  //     field: "description",
  //     name: "Mô tả tóm tắt",
  //     sortable: true,
  //     truncateText: true,
  //   },

  //   {
  //     field: "",
  //     name: "Trạng thái",
  //     sortable: true,
  //     truncateText: true,
  //     render: (online: tblFixedContent) => (
  //       <EuiLink
  //         target="_blank"
  //         onClick={async (e: any) => {
  //           await statusActive(online.id);
  //         }}
  //       >
  //         <EuiHealth color={getStatusColor(online.status)}>
  //           {online.status === "A" ? "Hiển thị" : "Không hiển thị"}
  //         </EuiHealth>
  //       </EuiLink>
  //     ),
  //   },
  //   {
  //     name: "Actions",
  //     width: "5%",
  //     render: (online: any) => {
  //       return (
  //         <>
  //           <EuiFlexGroup
  //             responsive={true}
  //             wrap={false}
  //             gutterSize="s"
  //             alignItems="center"
  //           >
  //             <EuiFlexItem grow={false}>
  //               <EuiButtonIcon
  //                 iconType="documentEdit"
  //                 aria-label="Dashboard"
  //                 color="success"
  //                 onClick={(e: any) => {
  //                   if (isNullOrUndefined(online))
  //                     NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
  //                   else {
  //                     editItem(online.id);
  //                   }
  //                 }}
  //               />
  //             </EuiFlexItem>
  //             <EuiFlexItem grow={false}>
  //               <EuiButtonIcon
  //                 iconType="trash"
  //                 color="danger"
  //                 onClick={(e: any) => {
  //                   if (isNullOrUndefined(online))
  //                     NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
  //                   else {
  //                     deleteItem([online.id]);
  //                   }
  //                 }}
  //               />
  //             </EuiFlexItem>
  //           </EuiFlexGroup>
  //         </>
  //       );
  //     },
  //   },
  // ];

  const getStatusColor = (status: any) => {
    switch (status) {
      case "I":
        return "red";
      case "A":
        return "green";
      default:
        return "subdued";
    }
  };

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [selectedOptions, setSelected] = useState();
  const [paramSearch, setParamSearch] = useState<ParamSearchBase>();
  const [datas, setDatas] = useState<tblFixedContent[]>([]);
  const [total, setTotal] = useState(0);
  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isError, setIsError] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [rowCount, setRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [selectIds, setSelectIds] = useState<any[]>([]);
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const handleEditData = async (id: number) => {
    if (id) {
      editItem(id);
    } else {
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    }
  };
  type SearchCriteria = {
    keySearch?: string;
  };
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {
      keySearch: _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    },
  });
  // const onTableChange = async ({
  //   page: { index, size },
  // }: CriteriaWithPagination<any>) => {
  //   setPagination({
  //     ...pagination,
  //     pageIndex: index,
  //     pageSize: size,
  //     totalItemCount: 1000,
  //   });
  // };

  // const onChange = (selectedOptions: any) => {
  //   setSelected(selectedOptions);
  //   if (!isNullOrUndefinedArry(selectedOptions)) {
  //     const value = selectedOptions[0].value;
  //     if (!isNullOrUndefined(value))
  //       setParamSearch({ ...paramSearch, inActive: value });
  //   } else setParamSearch({ ...paramSearch, inActive: undefined });
  // };

  // const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const key = event?.target?.value;
  //   if (!isNullOrUndefined(key))
  //     setParamSearch({ ...paramSearch, keyWord: key });
  // };

  // const onSelectionChange = (selectedItems: any[]) => {
  //   setSelectedItems(selectedItems);
  // };
  // const selection: EuiTableSelectionType<any> = {
  //   selectable: (user: any) => true,
  //   selectableMessage: (selectable: boolean) =>
  //     !selectable ? "User is currently offline" : "",
  //   onSelectionChange,
  // };

  const statusActive = async (id: number) => {
    if (id < 1)
      NotificationExtension.Fails("Mã nội dung cố định không tồn tại !");
    else {
      setLoading(true);
      const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
      try {
        let urlSearch = API_ROUTE.STATUS_FIX_CONTENT + "?id=" + id;
        let callapi = await repository.post<MessageResponse<boolean>>(
          urlSearch
        );
        if (isNullOrUndefined(callapi)) {
          NotificationExtension.Fails(
            "Thao tác không thành công, xin vui lòng thử lại !"
          );
        } else {
          if (callapi?.success) {
            NotificationExtension.Success("Thao tác thành công !");
            await fetchDataFixedContentType();
          } else NotificationExtension.Fails("Thao tác thất bại !");
        }
        return callapi?.data;
      } catch (error: any) {
        setError("Có lỗi xảy ra khi tải dữ liệu !");
        throw new Error(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const openModal = () =>
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Thêm mới nội dung cố định</Title>
          </div>
        </>
      ),
      children: <CreateView onSearch={() => fetchDataFixedContentType()} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });

  // const openModalEdit = () => {
  //   if (selectIds && (selectIds.length < 1 || selectIds.length > 1))
  //     NotificationExtension.Warn(
  //       "Xin vui lòng chọn 1 danh mục bài viết để chỉnh sửa !"
  //     );
  //   else {
  //     editItem(selectIds[0].id);
  //   }
  // };

  const openModalDelete = () => {
    if (selectIds && selectIds.length < 1)
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    else {
      deleteItem(selectIds);
    }
  };

  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa nội dung cố định</Title>
        </>
      ),
      children: (
        <DeleteView
          onSearch={() => fetchDataFixedContentType()}
          idItem={idItem}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(id: number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa nội dung cố định!</Title>
        </>
      ),

      children: (
        <EditView id={id} onSearch={() => fetchDataFixedContentType()} />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  }
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        size: 60,
      },
      {
        accessorKey: "title",
        header: "Danh sách nội dung cố định",
        // Cell: ({ cell }) => {
        //   const itemName = cell.getValue<string>();
        //   const item = datas.find((x) => x.title === itemName);
        //   return (
        //     <EuiLink
        //       target="_blank"
        //       onClick={() => {
        //         if (item && item.id > 0) handleEditData(item.id);
        //       }}
        //     >
        //       {itemName}
        //     </EuiLink>
        //   );
        // },
        size: 220,
      },
      {
        accessorKey: "linkIndex",
        header: "Link",
        Cell: ({ row }) => {
          const item = row.original.linkIndex;
          return (
            <Anchor>
              {item && item.trim() !== "" ? (
                <a
                  href={`${hacomUrl}${item}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#1976d2", textDecoration: "underline" }}
                >
                  Xem trang
                </a>
              ) : (
                <i style={{ color: "#aaa" }}>Không có link</i>
              )}
            </Anchor>
          );
        },
        size: 150,
      },
      {
        accessorKey: "image",
        header: "Ảnh nội dung cố định",
        Cell: ({ cell }) => {
          const uploadFile = cell.getValue<string | null>();
          return uploadFile ? (
            <EuiImage
              width={"100%"}
              height={100}
              src={convertImageDomain(uploadFile)}
              alt="file"
            />
          ) : null;
        },
        size: 200,
      },
      {
        accessorKey: "description",
        header: "Mô tả tóm tắt",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 300,
      },
      {
        id: "status",
        header: "Trạng thái",
        Cell: ({ row }) => {
          const online = row.original as tblFixedContent;
          return (
            <EuiLink
              target="_blank"
              onClick={async () => {
                await statusActive(online.id);
              }}
            >
              <EuiHealth color={getStatusColor(online.status)}>
                {online.status === "A" ? "Hiển thị" : "Không hiển thị"}
              </EuiHealth>
            </EuiLink>
          );
        },
        size: 150,
      },
      {
        id: "action",
        header: "Thao tác",
        Cell: ({ row }) => {
          const online = row.original;
          return (
            <Group justify="center" gap="xs">
              <Tooltip label="Chỉnh sửa">
                <ActionIcon
                  variant="subtle"
                  onClick={() => {
                    if (!online) {
                      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                    } else {
                      editItem(online.id);
                    }
                  }}
                >
                  <EuiButtonIcon iconType="documentEdit" color="success" />
                </ActionIcon>
              </Tooltip>

              <Tooltip label="Xoá">
                <ActionIcon
                  variant="light"
                  color="red"
                  onClick={async () => {
                    await deleteItem([online.id]);
                  }}
                >
                  <IconTrash size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
            </Group>
          );
        },
        size: 80,
        enableColumnActions: false,
        enableSorting: false,
      },
    ],
    [datas]
  );
  const fetchDataFixedContentType = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const search = form.getValues();
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    try {
      let urlSearch = `${API_ROUTE.GET_LIST_FIX_CONTENT}?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;
      if (search.keySearch) {
        urlSearch += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
      }
      let callapi = await repository.get<MessageResponse<any[]>>(urlSearch);
      if (callapi && callapi.success) {
        setDatas(callapi?.data ?? []);
        setRowCount(callapi?.totalCount ?? 0);
        setTotal(callapi?.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
      } else {
        setDatas([]);
        setRowCount(0);
        setIsLoading(false);
      }
      return callapi?.data;
    } catch (error: any) {
      setDatas([]);
      setIsError(true);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...form.getValues(),
          pageSize: pagination.pageSize,
          pageIndex: pagination.pageIndex,
        })
      );
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchDataFixedContentType();
    };
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);
  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);
  const table = useMantineReactTable({
    columns,
    data: datas,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    enableTopToolbar: false,
    enablePagination: true,
    localization: _localization,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableRowSelection: true,
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    getRowId: (row) => row.id,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    // mantineTableBodyRowProps: ({ row }) => ({
    //   onClick: row.getToggleSelectedHandler(),
    //   sx: { cursor: "pointer" },
    // }),
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (250 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  // useEffect(() => {
  //   if (_searchJson) {
  //     setPagination({
  //       pageIndex: _searchJson.pageIndex,
  //       pageSize: _searchJson.pageSize,
  //     });
  //   }
  // }, []);

  return (
    <>
      <BreadCrumb></BreadCrumb>
      <Divider my="sm" />
      {/* <AppSearch
        loading={loading}
        onChange={onChange}
        onChangeText={onChangeText}
        onSearch={() =>
          fetchDataFixedContentType(
            pagination.pageIndex,
            pagination.pageSize,
            paramSearch?.keyWord,
            paramSearch?.inActive
          )
        }
      /> */}
      <Grid justify="space-between" align="center" mb={10}>
        <Grid.Col span="auto">
          <Group gap="sm">
            <TextInput
              placeholder="Nhập tìm kiếm"
              key={form.key("keySearch")}
              leftSection={<IconSearch size={20} color="#15aabf" />}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchDataFixedContentType();
                }
              }}
              {...form.getInputProps("keySearch")}
              w={200}
            />
            <Button
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchDataFixedContentType();
              }}
            >
              Tìm kiếm
            </Button>
          </Group>
        </Grid.Col>

        <Grid.Col span="content">
          <Group justify="flex-end">
            <AppAction
              openModal={openModal}
              openModalDelete={openModalDelete}
            ></AppAction>
          </Group>
        </Grid.Col>
      </Grid>

      {/* <EuiSpacer size="l" /> */}
      {/* <EuiBasicTable
        tableCaption="Demo of EuiDataGrid with selection"
        items={datas ? datas : []}
        itemId="id"
        error={error}
        loading={loading}
        noItemsMessage={"Không có dữ liệu"}
        selection={selection}
        columns={columns}
        pagination={pagination}
        isSelectable={true}
        hasActions={true}
        responsive={true}
        onChange={onTableChange}
        compressed={true}
      /> */}
      <MantineReactTable table={table} />
    </>
  );
};

export default FixedContent;
